<template>

  <el-row :gutter="5">
    <el-col :span="5"></el-col>
    <el-col :span="12"><h2 class="heading">All Contract Agreements</h2></el-col>
    <el-col :span="7" style="padding-top:20px;text-align:left;">
        <el-button @click="$router.push('/contract/contractCalendar')">
            <el-icon><Calendar /></el-icon> &nbsp; Calendar</el-button> &nbsp; 
        <el-button @click="$router.push('/contract/editContract')" v-if="global.hasRight('contract', 'admin')">
            <el-icon><Plus/></el-icon> &nbsp; Add Contract</el-button>
    </el-col>
  </el-row>

  <el-row :gutter="5">
    <el-col :span="24" style="padding-left:40px;">
        <span class="label">Status</span>
        <el-select v-model="condition.status" placeholder="Select status" @change="selectStatus()" style="width:150px;" clearable>
            <el-option label="effective" value="effective"></el-option>
            <el-option label="expired" value="expired"></el-option>
            <el-option label="cancelled" value="cancelled"></el-option>
            <el-option label="ended" value="ended"></el-option>
        </el-select>
        <span class="label">Nature</span>
        <el-select v-model="condition.nature" placeholder="Select nature" @change="selectNature()" style="width:150px;" clearable>
            <el-option v-for="nature in natures" :key="nature" :label="nature" :value="nature"/>
        </el-select>
        <span class="label">Vendor</span>
        <el-select v-model="condition.vendor" placeholder="Select speaker" @change="selectVendor()" style="width:150px;" clearable>
            <el-option label="CSI" value="CSI"/>
            <el-option label="FTSE" value="FTSE"/>
            <el-option label="S&P" value="S&P"/>
            <el-option label="JPM" value="JPM"/>
            <el-option label="ICE" value="ICE"/>
            <el-option label="Factset" value="Factset"/>
            <el-option label="Bloomberg" value="Bloomberg"/>
            <el-option label="Linedata" value="Linedata"/>
            <el-option label="MorningStar" value="MorningStar"/>
        </el-select>
        <span class="label">Next Renew Date</span>
        <el-select v-model="condition.renewPeriod" placeholder="Select Date Range" @change="selectRenewPeriod()" style="width:170px;" clearable>
            <el-option label="Within 1 month" value="1M"/>
            <el-option label="Within 2 month" value="2M"/>
            <el-option label="Within 3 months" value="3M"/>
            <el-option label="Within 6 Months" value="6M"/>
            <el-option label="Within 1 Year" value="1Y"/>
        </el-select> 
        
        <span class="label">Next Cancel Date</span>
        <el-select v-model="condition.cancelPeriod" placeholder="Select Date Range" @change="selectCancelPeriod()" style="width:170px;" clearable>
            <el-option label="Within 1 month" value="1M"/>
            <el-option label="Within 2 month" value="2M"/>
            <el-option label="Within 3 months" value="3M"/>
            <el-option label="Within 6 Months" value="6M"/>
            <el-option label="Within 1 Year" value="1Y"/>
        </el-select> &nbsp;
        
    </el-col>
  </el-row>

  <el-table :data="contractList" height="88%" style="width:95%; margin:15px auto;" :row-class-name="tableRowClassName"
        :default-sort="{ prop: prop, order: order }" @sort-change="sortChange">
    <el-table-column prop="id" label="ID" align="center" sortable="custom" width="60"/>
    <el-table-column prop="nature" label="Nature" sortable="custom"/>
    <el-table-column prop="relatedETFs" label="ETFs"  sortable="custom">
        <template #default="scope">
            {{scope.row.relatedETFs.replace(",", ", ")}}
        </template>
    </el-table-column>
    <el-table-column prop="vendorName" label="Vendor" sortable="custom" align="center"/>
    <el-table-column prop="service" label="Service" width="200" sortable="custom"/>
    <el-table-column prop="effectiveDate" label="Effect Date" align="center" sortable="custom"/>
    <el-table-column prop="renewalTerm" label="Renew Term" align="center" sortable="custom"/>
    <el-table-column prop="nextRenewalDate" label="Renew Date" align="center" sortable="custom"/>
    <el-table-column prop="nextDateToCancel" label="Cancel Date" align="center" sortable="custom"/>
    <el-table-column prop="contractAmount" label="Contract Amount" align="center">
        <template #default="scope">
            {{scope.row.contractAmount > 0 ? this.global.number_format(scope.row.contractAmount, 2) : "-"}}
        </template>
    </el-table-column> 
    <el-table-column prop="currency" label="Ccy"  sortable="custom"/>
    <el-table-column prop="billingFrequency" label="Billing Freq."  sortable="custom"/>
    <!--el-table-column prop="noticePeriodForTermination" label="Notice period for termination" width="160"/-->
    <el-table-column prop="status" label="Action" align="center">
        <template #default="scope">
            <el-icon :size="16" @click="$router.push('/contract/viewContract?code=' + scope.row.idMD5)" style="cursor:pointer" 
                title="View details" class="op">
                <document />
            </el-icon>
            <el-icon :size="16" v-if="global.hasRight('contract', 'admin')"
                @click.prevent="$router.push('/contract/editContract?code=' + scope.row.idMD5)" title="Edit" class="op">
                <Edit/>
            </el-icon>
            <el-icon :size="16" v-if="global.hasRight('contract', 'admin')"
                @click="deleteContract(scope.row.idMD5)" title="Delete this contract"  class="op">
                <Delete />
            </el-icon>
        </template>
    </el-table-column>
  </el-table>
  
  <el-pagination background layout="prev, pager, next" :total="page.rowCount" :page-size="page.pageSize" :current-page="page.currPage"
    @current-change="getContractList" style="justify-content: center;"></el-pagination>

</template>

<script>

import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Document, Plus, Delete, Edit, Calendar } from '@element-plus/icons-vue'

export default {
    components: {
        Document,  Plus, Delete, Edit, Calendar
    },
    data() {
        return {
            natures: ['Index provider', 'System vendor', 'Index Data', 'Market Data', 'Professional', 'Listing agent', 'Cleaning services'],
            orderObj : {prop: "orderNo", order: "asc"},
            currentUser: null,
            contractList: [],
            page: {currPage: 1},
            errMsg: '',
            global,
            condition: {
                status: null,
                nature: null,
                vendor: null, 
                startDate: null,
                endDate: null,
                renewPeriod: null,
                cancelPeriod: null,
            },
        }
    },
    async mounted() {
        this.global.index = "contract";
        this.currentUser = this.global.currentUser;
        this.getContractList(1);
    },
    methods: {
        sortChange(orderObj) {
            this.orderObj = orderObj;
            this.getContractList(1);
        },
        async getContractList(pageNo) {
            this.page.currPage = pageNo;
            let data = {pageNo : pageNo}
            if (this.$route.query && this.$route.query.period)
                this.condition.renewPeriod = this.$route.query.period;

            if (this.condition.status) data.status = this.condition.status;
            if (this.condition.nature) data.nature = this.condition.nature;
            if (this.condition.vendor) data.vendor = this.condition.vendor;
            if (this.condition.renewPeriod) data.renewPeriod = this.condition.renewPeriod;
            if (this.condition.cancelPeriod) data.cancelPeriod = this.condition.cancelPeriod;

            if (this.orderObj.prop) {
                data["prop"] = this.orderObj.prop;
                data["order"] = this.orderObj.order;
            }
            let result = await AXIOS("/contract/getContractList", data);
            if (result.success) {
                this.contractList = result.data.contractList;
                this.page = result.data.page;
            } else {
                this.errMsg = result.errMsg;
            }
        },
        tableRowClassName(scope) {
            return scope.row.status;
        },
        selectStatus() {
            this.condition = {status: this.condition.status};
            this.getContractList(1);
        },
        selectNature() {
            this.condition = {nature: this.condition.nature};
            this.getContractList(1);
        },
        selectVendor() {
            this.condition = {vendor: this.condition.vendor};
            this.getContractList(1);
        },
        selectRenewPeriod() {
            this.condition = {renewPeriod: this.condition.renewPeriod};
            this.getContractList(1);
        },
        selectCancelPeriod() {
            this.condition = {cancelPeriod: this.condition.cancelPeriod};
            this.getContractList(1);
        },
        
        deleteContract(code) {
            ElMessageBox.confirm(
                'Are you sure want to delete this contract agreement?',  'Warning', {
                    confirmButtonText: 'OK', cancelButtonText: 'Cancel', type: 'warning',
                }
            ).then(async () => {
                let result = await AXIOS("/contract/deleteContract", {code : code});
                if (result.success) {
                    this.contractList.splice(this.contractList.findIndex(e => e.idMD5 == code), 1);
                    ElMessage({
                        message: 'Deleted contract agreement successfully!', type: 'success',
                    });
                } else {
                    ElMessage({
                        message: result.errMsg, type: 'error',
                    });
                }
            });
        }
    }
}
</script>

<style>
    .errMsg {
        padding-left:20px;
    }
    .successMsg {
        padding-left:20px;
    }
    .ended, .expired, .cancelled {
        color: #aaa;
    }
    .link {font-size:14px; color:#269; text-decoration: none; vertical-align: middle; margin-left:20px;}
    .link:active {color:#269;}
</style>